import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { BasicUser } from 'src/app/domain/models/User';
import { LoadOrderListItem } from 'src/app/domain/models/LoadOrder';
import { MasterLoad, PalletLoad, PalletPrice } from 'src/app/domain/models/Pallet';

import { TransportTypeUtils } from 'src/app/ui/util/transportType.Utils';
import { PalletGateway } from 'src/app/application/gateway/PalletGateway';
import { FilterService, MenuItem, MessageService, SelectItem } from 'primeng/api';
import { AuthApiService } from 'src/app/application/service/AuthService';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ProfileService } from 'src/app/application/service/ProfileService';
import { ProfileContactInfo } from 'src/app/domain/models/Profile';
import { Routes } from 'src/app/infrastructure/routes';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { FilterLoadsUtils, MyLoadsFilter } from 'src/app/ui/util/custom-filters-my-loads';


@Component({
  selector: 'app-user-load-pallets-orders',
  templateUrl: './user-load-pallets-orders.component.html',
  styleUrls: ['./user-load-pallets-orders.component.css'],

})
export class UserLoadPalletsOrdersComponent {

  profile: ProfileContactInfo | undefined
  companyName: string = ""
  orders: LoadOrderListItem[] = []
  shipments: LoadOrderListItem[] = []
  searchTerm: string = '';

  palletLoads: PalletLoad[] = []

  loading: boolean = false
  year: number = new Date().getFullYear()

  filteredRegisters: PalletLoad[] = []
  containerFilter: SelectItem[] = []
  weekFilter: SelectItem[] = []
  importerFilter: SelectItem[] = []
  specieFilter: SelectItem[] = []
  varietyFilter: SelectItem[] = []
  shipFilter: SelectItem[] = []

  filter: MyLoadsFilter | undefined;
  selectedCompanies!: string[];
  selectedContainers!: string[];
  lang: string = 'en';
  yearSelect: number[] = []

  years: number[] = []

  profileUser: BasicUser | undefined

  breadcrumbItems: MenuItem[] = []
  breadcrumbHomeItem: MenuItem = {}

  constructor(
    private _router: Router,
    private _messageService: MessageService,
    private _palletService: PalletGateway,
    public translateService: TranslateService,
    private _authService: AuthGateway,
    private _profileService: ProfileService

  ) {
    if (this._router.getCurrentNavigation()?.extras?.state?.['year'] !== undefined) {
      this.year = this._router.getCurrentNavigation()?.extras.state?.['year'];
    }
  }

  ngOnInit(): void {

    this.profileUser = this._authService.getUser()

    let breadcrumbMenuItemLabel1 = 'Pallets view'
    let breadcrumbHomeMenuItemLabel = 'My loads'

    if(this.profileUser) {
      switch(this.profileUser.lang) {
        case 'en':
          breadcrumbMenuItemLabel1 = 'Pallets view'
          breadcrumbHomeMenuItemLabel = 'My loads'
          break
        case 'es':
          breadcrumbMenuItemLabel1 = 'Vista Pallets'
          breadcrumbHomeMenuItemLabel = 'Mis cargas'
          break
      }
    }

    this.breadcrumbItems = [{ label: breadcrumbMenuItemLabel1, disabled: true}]
    this.breadcrumbHomeItem = { label: breadcrumbHomeMenuItemLabel, routerLink: '/' + Routes.userLoadOrders };


    this.getYears()
    this.loadMaster()
    this.companyName = this._authService.getUser()?.companyName ?? ""
    this._profileService.getContactInfo().subscribe({
      next: (v) => {
        this.profile =  v
      },
      error: (e) => {
        console.log(e)
        this._messageService.add({ severity: 'error',
          summary: this.translateService.instant('MessageService.Summary.FailedAction'),
          detail: this.translateService.instant('MessageService.ProfileMessageService.SingleRetrieveError') });
      },
    })
  }

  getYears() {
    let current = new Date()
    let currentYear = current.getFullYear()

    for(let i = 2023; i <= currentYear; i++) {
      this.years.push(i)
    }
  }

  filterTable(event: any) {
    let filterData  = event.filteredValue;
    this.buildFilters(filterData)
  }

  filterLoads() {
    if (!this.searchTerm.trim()) {
      // Si el término de búsqueda está vacío, mostrar todos los pedidos
      this.filteredRegisters = this.palletLoads;
    } else {
      // Filtrar los pedidos basados en el término de búsqueda
      this.filteredRegisters = this.palletLoads.filter(product =>
        product.importer?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.week?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.etd?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.eta?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.containerNumber?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.palletNumber?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.producer?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.species?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.variety?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.packaging?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.netKilos?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.boxType?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.boxesPerPallet?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.ship?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.departurePort?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.destinationPort?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.incoterms?.toLowerCase().includes(this.searchTerm.toLowerCase())
      )
    }
  }

  exportExcel(table: Table) {
    const tableExport = table.filteredValue ? table.filteredValue : this.filteredRegisters;

    import('xlsx').then((xlsx) => {
      let sheets: any[] = []
      if(tableExport) {
        tableExport.forEach(x => {
          let row = {
            [this.translateTextExcel('ImportOrderIdHeader')]: x.importOrderId,
            [this.translateTextExcel('ImporterHeader')]: x.importer,
            [this.translateTextExcel('WeeksHeader')]: x.week,
            [this.translateTextExcel('ETAHeader')]: x.etd,
            [this.translateTextExcel('ETDHeader')]: x.eta,
            [this.translateTextExcel('ContainerHeader')]: x.containerNumber,
            [this.translateTextExcel('PalletsHeader')]: x.palletNumber,
            [this.translateTextExcel('GrowerHeader')]: x.producer,
            [this.translateTextExcel('EspecieHeader')]: x.species,
            [this.translateTextExcel('VarietyHeader')]: x.variety,
            [this.translateTextExcel('PackagingHeader')]: x.packaging,
            [this.translateTextExcel('NetKilosHeader')]: x.netKilos,
            [this.translateTextExcel('LabelHeader')]: x.boxType,
            [this.translateTextExcel('BoxesPerPalletHeader')]: x.boxesPerPallet,
            [this.translateTextExcel('VesselNameHeader')]: x.ship,
            [this.translateTextExcel('OriginPortHeader')]: x.departurePort,
            [this.translateTextExcel('DestinationPortHeader')]: x.destinationPort,
            [this.translateTextExcel('PricePerBox')]: x.importOrderDetail?.price,
            [this.translateTextExcel('Incoterms')]: x.incoterms,
          }
          sheets.push(row)
        })
      }
      const worksheet = xlsx.utils.json_to_sheet(sheets);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      // Aplica formato de 2 decimales a la columna de precios
      const range = xlsx.utils.decode_range(worksheet['!ref'] || '');
      for (let R = range.s.r + 1; R <= range.e.r; ++R) { // Salta el encabezado
        const cellAddress = xlsx.utils.encode_cell({ r: R, c: 16 }); // Columna 16 (Precio)
        const cell = worksheet[cellAddress];
        if (cell && typeof cell.v === 'number') {
          cell.z =  '"$"#,##0.00_);\\("$"#,##0.00\\)';  // Formato de 2 decimales con signo de pesos
        }
      }

      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      let reportName = this.lang == 'es' ? 'Reporte Pallets' : 'Report Pallets';
      this.saveAsExcelFile(excelBuffer, reportName);
    });
  }

  @ViewChild('loadPalletsTable') dt: any;
  ngAfterContentInit(): void{
  }

  // Funcion para setear variables filtro
  configFilter()
  {

    this.filter = FilterLoadsUtils.getFilterConfig()

    if(this.filter)
    {
      if(this.filter.profileName)
      {
        this.selectedCompanies = [];
        this.selectedCompanies.push(this.filter.profileName)
        this.dt.filters['importer'] = [
          {value: this.selectedCompanies, matchMode: "in"}
        ]
      }

      if(this.filter.container)
      {
        this.selectedContainers = [];
        this.selectedContainers.push(this.filter.container)
        this.dt.filters['containerNumber'] = [{value: this.selectedContainers, matchMode: "in"}]
      }

      if(this.filter.year)
      {
        this.year = this.filter.year;
      }

    }

    this.updateSelectedYear()
  }

  translateTextExcel(text: string) {
    return this.translateService.instant(`UserPages.UserLoadPalletsOrders.MainTable.${text}`);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    let date = new Date()
    var FileSaver = require('file-saver');
    FileSaver.saveAs(data, fileName + '-' + date.getDate()  + '-' + (date.getMonth() + 1) + '-' +date.getFullYear() + EXCEL_EXTENSION);
  }

  loadMaster(){
    this.loading = true;
    let config = FilterLoadsUtils.getFilterProgramConfig()

    if(config){
      if(config.year){
        this.year = config.year
      }
    }
    this._palletService.getUserPalletLoad(this.year, false).subscribe({
      next: (v) => {
        this.loading = false;
        this.palletLoads = v
        this.filteredRegisters = v
        this.buildFilters(this.filteredRegisters)

        this.configFilter()
      },
      error: (e) => {
       this.loading = false
       console.log(e)
       this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los Master Loads.' });
     },
    })
  }

  buildFilters(palletLoad: PalletLoad[]){

    this.containerFilter = []
    this.weekFilter = []
    this.specieFilter = []
    this.shipFilter = []
    this.varietyFilter = []
    this.importerFilter = []

    palletLoad.forEach((item) => {
      if (item.containerNumber && !this.containerFilter.some((x) => x.label == item.containerNumber )) {
        this.containerFilter.push({ label: item.containerNumber, value: item.containerNumber })
      }
      if (item.week && !this.weekFilter.some( (x) => x.value === item.week)) {
        this.weekFilter.push({label:item.week.toString(), value: item.week} )
      }
      if (item.importer && !this.importerFilter.some(
        (x) => x.label === item.importer
      )) {
        this.importerFilter.push({ label: item.importer, value: item.importer })
      }
      if (item.species && !this.specieFilter.some((x) => x.label === item.species)) {
        this.specieFilter.push({label: item.species, value: item.species })
      }
      if (item.variety && !this.varietyFilter.some( (x) => x.label === item.variety)) {
        this.varietyFilter.push({label: item.variety, value: item.variety })
      }
      if (item.ship && !this.shipFilter.some((x) => x.label === item.ship)) {
        this.shipFilter.push({label: item.ship, value: item.ship} )
      }
    })


    this.weekFilter.sort((x) => x.value)
    this.containerFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.specieFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.shipFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.varietyFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.importerFilter.sort((a, b) => a.value.localeCompare(b.value))
  }

  getTransportName(transportType: number)
  {
    return TransportTypeUtils.getTransportName(this.translateService.currentLang, transportType);
  }

  goToLoadsPage(): void {
    this.clearFilters()
    this._router.navigate([Routes.userLoadOrders]);
  }

  clearFilters() {
    sessionStorage.removeItem("dt-masterload-session")
  }

  updateSelectedYear()
  {
    this.yearSelect = []
    this.yearSelect.push(this.year);
  }

  removeConfigFilter()
  {
    FilterLoadsUtils.removeFilterProgramConfig()
  }

  searchLoadContainers(event: any)
  {
    this.removeConfigFilter()
    if(event.value.length > 0)
    {
      this.year = event.value[0]
      this.loadMaster()
    }else{
      this.palletLoads = []
      this.filteredRegisters = []
      this.yearSelect = []
    }
  }
}
